// src/pages/LandingPage.js
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';

// Icons (features)
// ✅ إضافة FaUserCircle هنا
import { FaPalette, FaAddressCard, FaMobileAlt, FaLink, FaUserCircle } from 'react-icons/fa';
// Icons (footer)
import { FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';


// Real samples
import growuppreview from '../images/growup-preview.png';
import growuptechpreview from '../images/growuptech-preview.png';
import ismaelpreview from '../images/ismael-preview.png';

// Brand Logo
import brandLogo from '../images/growuptechlinktree.png'; 

// ❌ تم حذف استيراد صور الأفاتار هنا
// import avatar1 from '../images/avatar1.jpg';
// import avatar2 from '../images/avatar2.jpg';
// import avatar3 from '../images/avatar3.jpg';

/* ================= i18n strings ================= */
const STRINGS = {
  ar: {
    langName: 'العربية',
    nav: { features: 'الميزات', samples: 'عينات', how: 'كيف يعمل' },
    brand: 'GrowUp Link',
    hero: {
      title_1: 'كل روابطك في ',
      title_span: 'مكان واحد',
      desc:
        'أنشئ صفحتك الاحترافية لعرض كل ما يهمك — روابطك، حساباتك، وحتى بطاقة أعمالك الرقمية — كلها برابط واحد أنيق وسهل المشاركة.',
      cta_primary: 'أنشئ صفحتك الآن مجاناً',
      cta_secondary: 'شاهد العينات',
      bullets: [
        'ثيمات جاهزة + محرّر ثيم مخصص',
        'زر “حفظ جهة الاتصال” (vCard) تلقائي',
        'معاينة فورية داخل لوحة التحكم',
      ],
      claim_placeholder: 'your-username',
      claim_btn: 'احجز رابطك',
    },
    features: {
      title: 'أبرز الميزات الاحترافية',
      items: [
        { title: 'تصميم قابل للتخصيص', desc: 'اختر من بين ثيمات جاهزة أو صمّم ثيمك الخاص بالألوان والخطوط التي تعبّر عن هويتك.' },
        { title: 'بطاقة أعمال ذكية', desc: 'زر “حفظ جهة الاتصال” يضيف بياناتك مباشرةً لجهات اتصال الزائر بلمسة واحدة.' },
        { title: 'معاينة مباشرة', desc: 'شاهد التغييرات فورًا على محاكي الهاتف داخل لوحة التحكم قبل النشر.' },
        { title: 'كل أنواع الروابط', desc: 'أيقونات تواصل + روابط مخصصة قابلة للسحب والترتيب كما تريد.' },
      ],
    },
    samples: {
      // ... (كما هو) ...
      title: 'عينات صُنعت باستخدام GrowUp Link',
      subtitle: 'أمثلة واقعية توضح أشكال العرض المختلفة (Buttons / Chips / Grid / Icons)',
      card1_badge: 'شركة',
      card1_caption: 'GrowUp Tech — نمط الأزرار + زر حفظ جهة الاتصال',
      card2_badge: 'شخصي',
      card2_caption: 'Ismael — صفحة شخصية أنيقة بثيم متدرّج',
      card3_badge: 'شركة',
      card3_caption: 'GrowUp — غلاف بصري وهوية متناسقة',
      cta_primary: 'ابدأ صفحتك الآن',
      cta_secondary: 'جرّب مجاناً',
    },
    how: {
      // ... (كما هو) ...
      title: 'ابدأ بثلاث خطوات بسيطة',
      steps: [
        { title: 'أنشئ حسابك', desc: 'سجل حسابك المجاني في أقل من دقيقة.' },
        { title: 'أضف روابطك', desc: 'أضف روابط التواصل والروابط المخصصة التي تريد مشاركتها.' },
        { title: 'خصص وشارك', desc: 'اختر الثيم أو صمّم ثيمك الخاص، ثم شارك رابطك الفريد مع الجميع.' },
      ],
    },
    //  جديد: قسم آراء العملاء
    testimonials: {
      title: 'يثق بنا المبدعون والشركات',
      items: [
        // ✅ استخدام خاصية `icon: true` بدلاً من `avatar`
        { name: 'سارة خالد', role: 'مصممة جرافيك', quote: 'أفضل خدمة استخدمتها لتجميع أعمالي وروابطي. لوحة التحكم سهلة جداً والنتيجة احترافية!', icon: true },
        { name: 'أحمد العلي', role: 'مدير تسويق', quote: 'ميزة بطاقة الأعمال الذكية (vCard) رائعة. الآن يمكن لعملائي حفظ رقمي وإيميلي بضغطة واحدة.', icon: true },
        { name: 'GrowUp Tech', role: 'شركة تقنية', quote: 'استبدلنا بطاقاتنا الورقية بهذا الحل. ممتاز لفرق العمل، كل موظف له صفحته الخاصة بهويتنا البصرية.', icon: true },
      ]
    },
    finalCta: {
      title: 'جاهز لإنشاء صفحتك الاحترافية؟',
      desc: 'انضم الآن وابدأ في تجميع كل روابطك المهمة في مكان واحد.',
      btn: 'ابدأ مجاناً الآن',
    },
    //  جديد: الفوتر
    footer: {
      rights: 'All rights reserved.',
      quickLinks: 'روابط سريعة',
      legal: 'قانوني',
      terms: 'شروط الخدمة',
      privacy: 'سياسة الخصوصية',
      social: 'تابعنا',
      dev: 'تم التطوير بواسطة' // ✅ أضف هذا السطر
    },
    auth: { login: 'تسجيل الدخول', signup: 'سجّل مجاناً' },
  },

  en: {
    langName: 'English',
    nav: { features: 'Features', samples: 'Samples', how: 'How it Works' },
    brand: 'GrowUp Link',
    hero: {
      title_1: 'All your links in ',
      title_span: 'one place',
      desc:
        'Create a professional page for everything that matters—your links, social accounts, and even a smart business card—all under a single, shareable URL.',
      cta_primary: 'Create your page for free',
      cta_secondary: 'See samples',
      bullets: [
        'Ready-made themes + custom theme editor',
        'One-tap “Save Contact” (vCard)',
        'Live preview inside the dashboard',
      ],
      claim_placeholder: 'your-username',
      claim_btn: 'Claim your link',
    },
    features: {
      title: 'Powerful Features',
      items: [
        { title: 'Customizable Design', desc: 'Pick a ready theme or craft your own with colors and fonts that fit your brand.' },
        { title: 'Smart Business Card', desc: '“Save Contact” adds your info directly to visitors’ phones with one tap.' },
        { title: 'Live Preview', desc: 'See changes instantly on a phone mock inside your dashboard before publishing.' },
        { title: 'All Link Types', desc: 'Social icons + custom buttons with drag-and-drop ordering.' },
      ],
    },
    samples: {
      // ... (كما هو) ...
      title: 'Samples made with GrowUp Link',
      subtitle: 'Real examples of different display modes (Buttons / Chips / Grid / Icons)',
      card1_badge: 'Company',
      card1_caption: 'GrowUp Tech — Buttons layout + Save Contact',
      card2_badge: 'Personal',
      card2_caption: 'Ismael — Elegant personal page with gradient theme',
      card3_badge: 'Company',
      card3_caption: 'GrowUp — Visual cover and consistent branding',
      cta_primary: 'Start your page',
      cta_secondary: 'Try for free',
    },
    how: {
      // ... (كما هو) ...
      title: 'Get started in 3 simple steps',
      steps: [
        { title: 'Create an account', desc: 'Sign up for free in under a minute.' },
        { title: 'Add your links', desc: 'Add social links and custom URLs you want to share.' },
        { title: 'Customize & share', desc: 'Pick a theme or design your own, then share your unique link.' },
      ],
    },
    //  جديد: قسم آراء العملاء
    testimonials: {
      title: 'Trusted by creators and businesses',
      items: [
        // ✅ استخدام خاصية `icon: true` بدلاً من `avatar`
        { name: 'Sarah Khaled', role: 'Graphic Designer', quote: 'The best service I\'ve used to gather my portfolio and links. The dashboard is super easy and the result is professional!', icon: true },
        { name: 'Ahmed Al-Ali', role: 'Marketing Manager', quote: 'The vCard feature is fantastic. My clients can now save my number and email with a single tap.', icon: true },
        { name: 'GrowUp Tech', role: 'Tech Company', quote: 'We replaced our paper cards with this. Great for teams, each employee has a page with our brand identity.', icon: true },
      ]
    },
    finalCta: { title: 'Ready to build your pro page?', desc: 'Join now and bring all your links together.', btn: 'Start for free' },
    //  جديد: الفوتر
    footer: {
      rights: 'All rights reserved.',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      social: 'Follow Us',
      dev: 'Developed by' // ✅ أضف هذا السطر
    },
    auth: { login: 'Login', signup: 'Sign Up Free' },
  },

  he: {
    langName: 'עברית',
    nav: { features: 'תכונות', samples: 'דוגמאות', how: 'איך זה עובד' },
    brand: 'GrowUp Link',
    hero: {
      title_1: 'כל הקישורים שלך ',
      title_span: 'במקום אחד',
      desc:
        'צרו עמוד מקצועי לכל מה שחשוב — קישורים, חשבונות, ואפילו כרטיס ביקור חכם — הכול תחת כתובת שיתופית אחת.',
      cta_primary: 'יצירת עמוד בחינם',
      cta_secondary: 'צפו בדוגמאות',
      bullets: [
        'תבניות מוכנות + עורך תבניות מותאם',
        'כפתור “שמירת איש קשר” (vCard) בלחיצה',
        'תצוגה מקדימה חיה בלוח הבקרה',
      ],
      claim_placeholder: 'your-username',
      claim_btn: 'תפוס את הקישור',
    },
    features: {
      title: 'תכונות עוצמתיות',
      items: [
        { title: 'עיצוב מותאם', desc: 'בחרו תבנית מוכנה או עצבו בעצמכם עם צבעים ופונטים למותג שלכם.' },
        { title: 'כרטיס ביקור חכם', desc: '“שמירת איש קשר” מוסיף את פרטיכם ישירות לטלפון של המבקר.' },
        { title: 'תצוגה חיה', desc: 'ראו את כל השינויים מיד במוק-אפ טלפון לפני הפרסום.' },
        { title: 'כל סוגי הקישורים', desc: 'אייקוני רשתות + קישורים מותאמים עם גרירה וסידור.' },
      ],
    },
    samples: {
      // ... (كما هو) ...
      title: 'דוגמאות שנוצרו עם GrowUp Link',
      subtitle: 'דוגמאות אמיתיות למצבי תצוגה שונים (כפתורים / צ׳יפס / גריד / אייקונים)',
      card1_badge: 'חברה',
      card1_caption: 'GrowUp Tech — פריסת כפתורים + שמירת איש קשר',
      card2_badge: 'אישי',
      card2_caption: 'Ismael — עמוד אישי אלגנטי עם גרדיאנט',
      card3_badge: 'חברה',
      card3_caption: 'GrowUp — שער חזותי ומיתוג עקבי',
      cta_primary: 'התחילו עכשיו',
      cta_secondary: 'נסו בחינם',
    },
    how: {
      // ... (كما هو) ...
      title: 'שלושה שלבים פשוטים',
      steps: [
        { title: 'פתחו חשבון', desc: 'הרשמה בחינם בפחות מדקה.' },
        { title: 'הוסיפו קישורים', desc: 'הוסיפו קישורי רשת וקישורים מותאמים לשיתוף.' },
        { title: 'התאימו ושיתפו', desc: 'בחרו תבנית או עצבו בעצמכם ושתפו את הקישור הייחודי שלכם.' },
      ],
    },
    //  جديد: قسم آراء العملاء
    testimonials: {
      title: 'יוצרים ועסקים סומכים עלינו',
      items: [
        // ✅ استخدام خاصية `icon: true` بدلاً من `avatar`
        { name: 'שרה חאלד', role: 'מעצבת גרפית', quote: 'השירות הכי טוב שאי פעם השתמשתי בו לאיסוף העבודות והקישורים שלי. קל לתפעול והתוצאה מקצועית!', icon: true },
        { name: 'אחמד עלי', role: 'מנהל שיווק', quote: 'פיצ\'ר ה-vCard מדהים. הלקוחות שלי יכולים לשמור את המספר והמייל שלי בלחיצה אחת.', icon: true },
        { name: 'GrowUp Tech', role: 'חברת טכנולוגיה', quote: 'החלפנו את כרטיסי הנייר שלנו בפתרון הזה. מעולה לצוותים, לכל עובד יש עמוד עם זהות המותג שלנו.', icon: true },
      ]
    },
    finalCta: { title: 'מוכנים לעמוד מקצועי?', desc: 'הצטרפו עכשיו ואספו את כל הקישורים למקום אחד.', btn: 'התחילו בחינם' },
    //  جديد: الفوتر
    footer: {
      rights: 'כל הזכויות שמורות.',
      quickLinks: 'קישורים מהירים',
      legal: 'משפטי',
      terms: 'תנאי שימוש',
      privacy: 'מדיניות פרטיות',
      social: 'עקבו אחרינו',
      dev: 'פותח על ידי' // ✅ أضف هذا السطر
    },
    auth: { login: 'כניסה', signup: 'הרשמה חינם' },
  },
};

const detectInitialLang = () => {
  const saved = localStorage.getItem('lang');
  if (saved && STRINGS[saved]) return saved;
  const nav = (navigator.language || 'en').toLowerCase();
  if (nav.startsWith('ar')) return 'ar';
  if (nav.startsWith('he')) return 'he';
  return 'en';
};

function LandingPage() {
  const [lang, setLang] = useState(detectInitialLang());
  const T = useMemo(() => STRINGS[lang], [lang]);
  const isRTL = lang === 'ar' || lang === 'he';

  const [lightbox, setLightbox] = useState({ open: false, src: '', alt: '' });
  const openLightbox = (src, alt) => setLightbox({ open: true, src, alt });
  const closeLightbox = () => setLightbox({ open: false, src: '', alt: '' });

  const [mobileOpen, setMobileOpen] = useState(false);

  const [claimUser, setClaimUser] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);
  

  useEffect(() => {
    localStorage.setItem('lang', lang);
    const html = document.documentElement;
    html.setAttribute('lang', lang);
    html.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  }, [lang, isRTL]);

  const changeLang = (l) => setLang(l);

  const handleClaim = (e) => {
    e.preventDefault();
    if (claimUser) {
      navigate('/login'); 
    }
  };

  return (
    <div className={`landing-page ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      {/* ... (الناف بار والهيرو كما هما) ... */}

      {/* NAV */}
      <nav className="landing-nav">
        <div className="nav-left">
          <button
            className={`hamburger ${mobileOpen ? 'is-active' : ''}`}
            aria-label="Toggle menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>

        <Link to="/" className="nav-logo">
          <img src={brandLogo} alt={T.brand} />
        </Link>
        </div>

        <div className="nav-links">
          <a href="#features">{T.nav.features}</a>
          <a href="#samples">{T.nav.samples}</a>
          <a href="#how-it-works">{T.nav.how}</a>
          <a href="#testimonials">{T.testimonials.title.split(' ')[0]}</a> 
        </div>

        <div className="nav-right">
          <div className="lang-switch">
            <button className={`lang-btn ${lang === 'ar' ? 'active' : ''}`} onClick={() => changeLang('ar')} aria-label="Arabic">AR</button>
            <button className={`lang-btn ${lang === 'en' ? 'active' : ''}`} onClick={() => changeLang('en')} aria-label="English">EN</button>
            <button className={`lang-btn ${lang === 'he' ? 'active' : ''}`} onClick={() => changeLang('he')} aria-label="Hebrew">HE</button>
          </div>

          <div className="nav-buttons">
            <Link to="/login" className="btn btn-secondary">{T.auth.login}</Link>
            <Link to="/login" className="btn btn-primary">{T.auth.signup}</Link>
          </div>
        </div>

        {/* Mobile sheet menu */}
        {mobileOpen && (
  <div className="mobile-menu" onClick={() => setMobileOpen(false)}>
    <div
      className={`mobile-menu-inner ${isRTL ? 'rtl' : 'ltr'}`}
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-label="Mobile navigation"
    >
      <div className="mobile-grip" aria-hidden="true" />

      <div className="mobile-menu-header">
        <Link to="/" className="brand-mini" onClick={() => setMobileOpen(false)}>
          <img src={brandLogo} alt={T.brand} />
        </Link>
        <button
          className="mobile-close"
          onClick={() => setMobileOpen(false)}
          aria-label="Close menu"
        >
          ×
        </button>
      </div>

      <nav className="mobile-list">
        <a href="#features" onClick={() => setMobileOpen(false)} className="mobile-item">
          {T.nav.features}
        </a>
        <a href="#samples" onClick={() => setMobileOpen(false)} className="mobile-item">
          {T.nav.samples}
        </a>
        <a href="#how-it-works" onClick={() => setMobileOpen(false)} className="mobile-item">
          {T.nav.how}
        </a>
        <a href="#testimonials" onClick={() => setMobileOpen(false)} className="mobile-item">
          {T.testimonials.title.split(' ')[0]}
        </a>
      </nav>

      <div className="mobile-section">
        <div className="mobile-section-title">Language</div>
        <div className="mobile-lang">
          <button
            className={`lang-btn ${lang === 'ar' ? 'active' : ''}`}
            onClick={() => { changeLang('ar'); setMobileOpen(false); }}
          >
            AR
          </button>
          <button
            className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
            onClick={() => { changeLang('en'); setMobileOpen(false); }}
          >
            EN
          </button>
          <button
            className={`lang-btn ${lang === 'he' ? 'active' : ''}`}
            onClick={() => { changeLang('he'); setMobileOpen(false); }}
          >
            HE
          </button>
        </div>
      </div>

      <div className="mobile-divider" />

      <div className="mobile-actions">
        <Link to="/login" className="btn btn-secondary" onClick={() => setMobileOpen(false)}>
          {T.auth.login}
        </Link>
        <Link to="/login" className="btn btn-primary" onClick={() => setMobileOpen(false)}>
          {T.auth.signup}
        </Link>
      </div>
    </div>
  </div>
)}

      </nav>

      {/* HERO */}
      <header className="landing-hero">
        <div className="hero-content">
          <h1>
            {T.hero.title_1}
            <span>{T.hero.title_span}</span>
          </h1>
          <p>{T.hero.desc}</p>

          <form className="hero-claim" onSubmit={handleClaim}>
            <span className="hero-claim-prefix">growup.link/</span>
            <input 
              type="text" 
              placeholder={T.hero.claim_placeholder} 
              value={claimUser}
              onChange={(e) => setClaimUser(e.target.value.toLowerCase().replace(/[^a-z0-9_.]/g, ''))}
            />
            <button type="submit" className="btn btn-primary">{T.hero.claim_btn}</button>
          </form>

          <ul className="hero-bullets">
            {T.hero.bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        </div>

        <div className="hero-stack" aria-hidden="true">
          <img loading="lazy" src={growuptechpreview} alt="GrowUp Tech sample" className="stack-img img-1" />
          <img loading="lazy" src={ismaelpreview} alt="Ismael sample" className="stack-img img-2" />
          <img loading="lazy" src={growuppreview} alt="GrowUp sample" className="stack-img img-3" />
        </div>
      </header>

      {/* FEATURES */}
      <section id="features" className="landing-features">
        <h2>{T.features.title}</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon"><FaPalette /></span>
            <h3>{T.features.items[0].title}</h3>
            <p>{T.features.items[0].desc}</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FaAddressCard /></span>
            <h3>{T.features.items[1].title}</h3>
            <p>{T.features.items[1].desc}</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FaMobileAlt /></span>
            <h3>{T.features.items[2].title}</h3>
            <p>{T.features.items[2].desc}</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon"><FaLink /></span>
            <h3>{T.features.items[3].title}</h3>
            <p>{T.features.items[3].desc}</p>
          </div>
        </div>
      </section>

      {/* SAMPLES */}
      <section id="samples" className="samples">
        <div className="samples-headline">
          <h2>{T.samples.title}</h2>
          <p>{T.samples.subtitle}</p>
        </div>

        <div className="samples-grid">
          <figure className="sample-card" onClick={() => openLightbox(growuptechpreview, 'GrowUp Tech')}>
            <span className="sample-badge">{T.samples.card1_badge}</span>
            <img loading="lazy" src={growuptechpreview} alt="GrowUp Tech sample" />
            <figcaption>{T.samples.card1_caption}</figcaption>
          </figure>

          <figure className="sample-card" onClick={() => openLightbox(ismaelpreview, 'Ismael Personal')}>
            <span className="sample-badge">{T.samples.card2_badge}</span>
            <img loading="lazy" src={ismaelpreview} alt="Ismael sample" />
            <figcaption>{T.samples.card2_caption}</figcaption>
          </figure>

          <figure className="sample-card" onClick={() => openLightbox(growuppreview, 'GrowUp Brand')}>
            <span className="sample-badge">{T.samples.card3_badge}</span>
            <img loading="lazy" src={growuppreview} alt="GrowUp brand sample" />
            <figcaption>{T.samples.card3_caption}</figcaption>
          </figure>
        </div>

        <div className="samples-cta">
          <Link to="/login" className="btn btn-primary">{T.samples.cta_primary}</Link>
          <Link to="/login" className="btn btn-ghost">{T.samples.cta_secondary}</Link>
        </div>
      </section>
      
      {/* جديد: قسم آراء العملاء */}
      <section id="testimonials" className="testimonials">
        <h2>{T.testimonials.title}</h2>
        <div className="testimonials-grid">
          {T.testimonials.items.map((item, i) => (
            <div className="testimonial-card" key={i}>
              <blockquote>"{item.quote}"</blockquote>
              <div className="testimonial-author">
                {/* ✅ تعديل هنا: استخدم الأيقونة بدلاً من الصورة */}
                {item.icon ? (
                  <FaUserCircle className="testimonial-avatar-icon" />
                ) : (
                  <img src={item.avatar} alt={item.name} className="testimonial-avatar" />
                )}
                <div className="testimonial-info">
                  <span className="testimonial-name">{item.name}</span>
                  <span className="testimonial-role">{item.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how-it-works" className="how-it-works">
        <h2>{T.how.title}</h2>
        <div className="steps-container">
          {T.how.steps.map((s, i) => (
            <div className="step-card" key={i}>
              <span className="step-number">{i + 1}</span>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="final-cta">
        <h2>{T.finalCta.title}</h2>
        <p>{T.finalCta.desc}</p>
        <Link to="/login" className="btn btn-primary">{T.finalCta.btn}</Link>
      </section>

      {/* جديد: الفوتر الاحترافي */}
      <footer className="landing-footer">
      <div className="footer-grid">
          <div className="footer-col" id="col-brand">
            <img src={brandLogo} alt={T.brand} className="footer-logo" />
            <p>&copy; {new Date().getFullYear()} {T.brand}. {T.footer.rights}</p>
            
            {/* ✅ السطر الجديد الذي تمت إضافته */}
            <p className="footer-dev">
              {T.footer.dev}{' '}
              <a href="https://growup.tech" target="_blank" rel="noopener noreferrer">
                Grow Up Tech
              </a>
            </p>
            {/* ============================== */}

          </div>
          
          <div className="footer-col">
            <h4>{T.footer.quickLinks}</h4>
            <a href="#features">{T.nav.features}</a>
            <a href="#samples">{T.nav.samples}</a>
            <a href="#how-it-works">{T.nav.how}</a>
          </div>

          <div className="footer-col">
            <h4>{T.footer.legal}</h4>
            <a href="/terms">{T.footer.terms}</a>
            <a href="/privacy">{T.footer.privacy}</a>
          </div>

          <div className="footer-col">
            <h4>{T.footer.social}</h4>
            <div className="footer-social-icons">
              <a href="https://twitter.com/yourbrand" aria-label="Twitter" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://instagram.com/yourbrand" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://linkedin.com/company/yourbrand" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            </div>
          </div>
        </div>
      </footer>

      {/* LIGHTBOX */}
      {lightbox.open && (
        <div className="lightbox" onClick={closeLightbox}>
          <img src={lightbox.src} alt={lightbox.alt} onClick={(e) => e.stopPropagation()} />
          <button className="lightbox-close" onClick={closeLightbox} aria-label="Close">×</button>
        </div>
      )}
    </div>
  );
}

export default LandingPage;